import React from "react";
import { withRouter } from "../_shared/withRouter";
import ResetTokenComponent from "../template/auth/resetToken";

const ForgotPassword = () => {
  return <ResetTokenComponent roleType={"superadmin"} role={"1"} />;
};

export default withRouter(ForgotPassword);
